<!-- TODO need to handle exisitng QB and Quacca with Launch Darkly -->
<lazy-component
    *ngIf="quickbetShown && !quaccaLdEnabled()"
    moduleUri="@quickbetModule/quickbet.module#QuickbetModule"
    [inputs]="{ selection: selection, betslipType: 'quickbet_stakes', isQuickBet: true }"
    entryComponent="QuickbetComponent">
</lazy-component>

<!-- *************** QUACCA BAR **************** -->
@if (quaccaLdEnabled()) {
    <lazy-component
        [style.display]="hideQuaccaOnStream() ? 'none' : 'initial'"
        [inputs]="{ selection: selections, betslipType: 'quaccabar_stakes', isLadbrokes: isLadbrokes }"
        moduleUri="@lazy-modules-module/quaccabar/quaccabar.module#QuaccabarModule"
        [entryComponent]="isLadbrokes ? 'LadbrokesQuaccaBarComponent' : 'QuaccaBarComponent'">
    </lazy-component>
}
